import React from "react";
import NotFound from "components/error/notFound";

const NotFoundPage = () => {
  return <NotFound></NotFound>;
};

export default NotFoundPage;
